// Ruajtja e token-it te sesionit per kerkim (qellimi "kerkim", i leshuar nga
// Services/TokeniKerkimit pas nje sfide Turnstile). Nje sfide njerezore mbulon N kerkime
// brenda TTL-se, ne vend te nje sfide per cdo kerkim.
//
// Ruhet ne sessionStorage qe te mbijetoje kalimin mes faqeve (komponenti i kerkimit
// rimontohet), por jo mbylljen e tabit. Serveri mbetet autoritet: kufiri i perdorimeve
// dhe skadimi verifikohen atje, kjo eshte vetem nje kesh lokal.

const CELESI = 'arbk_kerkimi_sesioni';

// Marzhe sigurie: mos e perdor token-in qe skadon brenda 10 sekondave, se kerkesa
// mund ta gjeje te skaduar ne server.
const MARZHI_SEKONDA = 10;

const ruajSesionin = (teDhenat) => {
    if (!teDhenat || !teDhenat.token) return;
    try {
        window.sessionStorage.setItem(
            CELESI,
            JSON.stringify({ token: teDhenat.token, skadonMe: teDhenat.skadonMe }),
        );
        // eslint-disable-next-line no-empty
    } catch (e) {}
};

const merrSesionin = () => {
    try {
        const rreshti = window.sessionStorage.getItem(CELESI);
        if (!rreshti) return '';
        const sesioni = JSON.parse(rreshti);
        if (!sesioni || !sesioni.token) return '';
        const tani = Math.floor(Date.now() / 1000);
        if (!sesioni.skadonMe || sesioni.skadonMe - MARZHI_SEKONDA <= tani) {
            window.sessionStorage.removeItem(CELESI);
            return '';
        }
        return sesioni.token;
    } catch (e) {
        return '';
    }
};

const pastroSesionin = () => {
    try {
        window.sessionStorage.removeItem(CELESI);
        // eslint-disable-next-line no-empty
    } catch (e) {}
};

export { ruajSesionin, merrSesionin, pastroSesionin };
